import styled from 'styled-components';

export const CartSummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;

  @media (max-width: 840px) {
    display: ${({ displayMode }) => (displayMode === 'desktop' ? 'none' : 'flex')};
    gap: 0;
  }
`;

export const PriceColumns = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  ${({ displayMode }) => displayMode === 'mobile' && 'display: none;'}

  @media (max-width: 840px) {
    display: none;
  }
`;

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #F8F7F5;
  border-radius: 8px;
  padding: 6px 10px;
  min-height: 36px;
  box-sizing: border-box;
`;


export const PriceLabel = styled.span`
  font-family: 'Verizon-NHG-eTX', sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: ${({ isSavings }) => (isSavings ? '#008331' : '#6F7171')};
  text-align: center;
`;

export const PriceValue = styled.span`
  font-family: 'Verizon-NHG-eTX', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: ${({ isSavings }) => (isSavings ? '#008331' : '#000000')};
  text-align: center;
`;

export const CartIconButton = styled.button`
  background: none;
  border: none;
  border-radius: 0;
  padding: 4px;
  min-height: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #000000;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid #EE001E;
    outline-offset: 2px;
    border-radius: 4px;
  }

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 840px) {
    padding: 4px;
  }
`;

export const CartIconGlyph = styled.span`
  position: relative;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CartIconSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  margin-left: 4px;
  border-left: 1px solid #D8DADA;

  @media (max-width: 840px) {
    border-left: none;
    padding-left: 0;
    margin-left: 0;
  }
`;

/**
 * Optional badge on the cart icon showing item count.
 */
export const CartBadge = styled.span`
  position: absolute;
  top: -1px;
  right: -1px;
  background: #EE001E;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  display: block;
  box-sizing: border-box;
`;
